export { default as reducer } from "./hidden.ducks";


// WEBPACK FOOTER //
// ./src/routes/Hidden/index.ts